import React from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import {TextEditorValue} from "./types";


const TextEditor = ({value, setValue}: TextEditorValue) => {
    const modules = {
        toolbar: [
            [{header: [1, 2, 3, 4, 5, 6, false]}],
            [{font: []}],
            [{size: ['small', false, 'large', 'huge']}],
            ['bold', 'italic', 'underline', 'strike'],
            [{script: 'sub'}, {script: 'super'}],
            [{color: []}, {background: []}],
            [{align: []}],
            [{indent: '-1'}, {indent: '+1'}],
            [{direction: 'rtl'}],
            [{list: 'ordered'}, {list: 'bullet'}, {list: 'check'}],
            ['blockquote', 'code-block'],
            ['link', 'image', 'video'],
            ['clean'],
        ],
        clipboard: {
            matchVisual: false,
        },
        history: {
            delay: 1000,
            maxStack: 100,
            userOnly: true,
        },
    };

    const formats = [
        'header',
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'script',
        'color',
        'background',
        'align',
        'indent',
        'direction',
        'list',
        'bullet',
        'blockquote',
        'code-block',
        'link',
        'image',
        'video',
    ];
    return (
        <div>
            <ReactQuill
                theme="snow"
                value={value}
                onChange={setValue}
                modules={modules}
                formats={formats}
                placeholder="Write something..."
                style={{height: 300, marginBottom: 70}}
            />
        </div>
    );
};

export default TextEditor;